var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit / Select_Multiple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 7V17.4C1 17.9601 1 18.2399 1.10899 18.4538C1.20487 18.642 1.35774 18.7952 1.5459 18.8911C1.7596 19 2.0395 19 2.59846 19H13.0001M15 6L11 10L9 8M5 11.8002V4.2002C5 3.08009 5 2.51962 5.21799 2.0918C5.40973 1.71547 5.71547 1.40973 6.0918 1.21799C6.51962 1 7.08009 1 8.2002 1H15.8002C16.9203 1 17.4801 1 17.9079 1.21799C18.2842 1.40973 18.5905 1.71547 18.7822 2.0918C19.0002 2.51962 19.0002 3.07969 19.0002 4.19978V11.7998C19.0002 12.9199 19.0002 13.48 18.7822 13.9078C18.5905 14.2841 18.2842 14.5905 17.9079 14.7822C17.4805 15 16.9215 15 15.8036 15H8.1969C7.07899 15 6.5192 15 6.0918 14.7822C5.71547 14.5905 5.40973 14.2842 5.21799 13.9079C5 13.4801 5 12.9203 5 11.8002Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOb);
export default __webpack_public_path__ + "static/media/OB.e6b907f40702eee246697128ff5829fd.svg";
export { ForwardRef as ReactComponent };